export const removeTemplateFromDenormalizedState = (
  workingState,
  templateId,
) => {
  const updatedWorkingState = { ...workingState };
  updatedWorkingState.templatesWorkingState = updatedWorkingState.templatesWorkingState.filter(
    template => template.id !== templateId,
  );
  return updatedWorkingState;
};

export default ({
  modelWorkingStateDenormalized,
  updateModelWorkingState,
  templateStatus,
  removeTemplateFromWorkingState,
  modelId,
  templateId,
}) => () => {
  if (templateStatus === 'inCart') {
    const newWorkingState = removeTemplateFromDenormalizedState(
      modelWorkingStateDenormalized,
      templateId,
    );
    updateModelWorkingState(newWorkingState);
  } else {
    removeTemplateFromWorkingState(modelId, templateId);
  }
};
